const enum CardTypeEnum {
  Colours = 'colours',
  Inspirations = 'inspirations',
  Products = 'products',
}

export default CardTypeEnum;
